import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NormalizedFieldState, NormalizedUIField } from '../../store/config.models';
import { FieldType } from '../../store/models/field-models';
import { UIElementType } from '../../store/models';

@Component({
    selector: 'app-field-renderer',
    templateUrl: './field-renderer.component.html',
    styleUrls: ['./field-renderer.component.scss'],
})
export class FieldRendererComponent {
    @Input() field: NormalizedFieldState;
    @Input() control: FormControl;
    @Input() fieldId: string;
    @Input() isReadOnly = false;

    FieldType = FieldType;
    UIElementType = UIElementType;

    constructor() {}

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    isUIField(field: NormalizedFieldState): field is NormalizedUIField {
        return field.type === FieldType.UI;
    }

    getUIType(field: NormalizedFieldState): UIElementType | undefined {
        return this.isUIField(field) ? field.uiType : undefined;
    }
}
